import { render, staticRenderFns } from "./TripsTable.vue?vue&type=template&id=aef4e996"
import script from "./TripsTable.vue?vue&type=script&lang=js"
export * from "./TripsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports